/*
 * @Author: 李朋飞
 * @Date: 2021-07-15 19:01:53
 * @LastEditTime: 2021-07-15 19:05:40
 * @Description: vuex 入口文件
 */
import Vue from "vue";
import Vuex from 'vuex';
import state from './state';
import mutations from './mutations';
import * as actions from './actions';
import * as getters from './getters';

Vue.use(Vuex);
//引入持久化插件
import VuexPersistence from 'vuex-persist'
//实例化我们的插件
const vuexLocal = new VuexPersistence({
  //用什么方法存储
  storage: window.sessionStorage,
  //对vuex中state状态进行选择性存储，用reducer的方法，返回一个对象 
  //注意:返回对象的属性必须和state中的属性一致 
  reducer: state => { return { menuList: state.menuList, routerListNew: state.routerListNew, isQyk: state.isQyk ,isQyzhgl: state.isQyzhgl ,isSjgl: state.isSjgl ,isSjdp: state.isSjdp ,isMhgl: state.isMhgl ,isEgOrBos: state.isEgOrBos ,isQx: state.isQx ,} }
})

export default new Vuex.Store({
  //挂载我们的插件
  plugins: [vuexLocal.plugin],
  state,
  mutations,
  actions,
  getters,
})


// WEBPACK FOOTER //
// ./src/store/index.js